module.exports = __webpack_public_path__ + "media/img/help_center/Student_Account_Creation_02-94c1ddc60a73916153ce63a6ba182ceb.jpg";